import { typography } from '@/design-system/tokens/typography';

interface TitleProps {
  title: string;
  className?: string;
}

const ActivityTitle = ({ title, className = '' }: TitleProps) => {
  return (
    <div>
      <h2
        className={`font-semibold text-black md:mt-8 mt-5 md:mb-5 mb-3 capitalize text-left ${className}`}
        style={{
          fontSize: typography.size.lg, // 18px
          fontFamily: typography.fonts.primary,
          lineHeight: 'normal',
        }}
      >
        {title}
      </h2>
    </div>
  );
};

export default ActivityTitle;
